import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../Components/profilebody/profilebody.module.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { addAccountUserThunk, updateUserAccountThunk } from '../../../../Website/redux/AccountUserSlice';
import { useNavigate } from 'react-router-dom';
import EditAccountUser from '../../Pages/addNewUser/EditAccountUser';

const ViewUserCamp = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const {loading,userDetails} = useSelector((state)=>state.accountUser)
    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

   

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        resetForm,
        setFieldValue,
        isSubmitting
    } = useFormik({
        initialValues: {
            fullName:userDetails?.fullName ||'',
            phone: userDetails?.phone ||'',
            email: userDetails?.email || '',
            password: userDetails?.password || '',
            confirmPassword:userDetails?.password || '',
        },
        onSubmit: async(values) => {
          
        },
    });

    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <h2>Edit user</h2>
                <button className={styles.editbtn} onClick={()=>navigate(-1)}>Back to List</button>

            </div>

            <form className={styles.profilebodyContent} onSubmit={handleSubmit}>
                <div className={styles.profilebodyDetails} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Full name
                            <div className={styles.logininputContainer}>
                                <input
                                 
                                    value={values.fullName}
                                    disabled={true}
                                    style={{background:'white'}}
                                />
                            </div>
                           
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Phone number
                            <div className={styles.logininputContainer}>
                                <input
                                  
                                    value={values.phone}
                                    disabled={true}
                                    style={{background:'white'}}
                                />
                            </div>
                          
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '49.2%' }}>
                            Email id
                            <div className={styles.logininputContainer}>
                                <input
                                   
                                    value={values.email}
                                    disabled={true}
                                    style={{background:'white'}}
                                />
                            </div>
                           
                        </label>
                    </div>
                    <div style={{ display: 'flex', gap: '14px' }}>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            New Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                   
                                    value={values.password}
                                    disabled={true}
                                    style={{background:'white'}}
                                />
                                <FontAwesomeIcon
                                    icon={showPassword ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={togglePasswordVisibility}
                                />

                            </div>
                           
                        </label>
                        <label className={styles.addCatLabel} style={{ width: '50%' }}>
                            Confirm Password
                            <div className={styles.logininputContainer}>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    
                                    value={values.confirmPassword}
                                    disabled={true}
                                    style={{background:'white'}}
                                />
                                <FontAwesomeIcon
                                    icon={showConfirmPassword ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={toggleConfirmPasswordVisibility}
                                />
                            </div>
                          
                        </label>
                    </div>
                    

                </div>
            </form>
        </div>
    )
}

export default ViewUserCamp